import { getBackgroundColorClass, getColorClass } from "../../ui";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export const Button = ({
  action,
  text,
  color = "primary",
  fullWidth,
  size = "sm",
  startIcon,
  endIcon,
  variant,
  isDisabled,
  children,
}) => {
  const iconProps = {
    size: 20,
  };
  const isLink = variant === "link";
  return (
    <button
      type="button"
      onClick={action}
      className={classNames(
        `flex items-center justify-center rounded-md text-${size} ${
          fullWidth && "w-full"
        } rounded-${size} ${
          isLink ? "bg-transparent shadow-none" : getBackgroundColorClass(color)
        } p-2 font-semibold border-none ${
          isLink ? getColorClass(color) : "text-white"
        } shadow-sm hover:opacity-80 cursor-pointer`
      )}
      disabled={isDisabled}
    >
      {startIcon && startIcon(iconProps)}
      {text || children}
      {endIcon && endIcon(iconProps)}
    </button>
  );
};
